/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumSuche: {
    name: 'big-medium-suche';
    data: string;
} = {
    name: 'big-medium-suche',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M76 3a49 49 0 0 0-38 79.91L4.47 116.46a5 5 0 0 0 7.07 7.08L45.09 90A49 49 0 1 0 76 3m0 88a39 39 0 1 1 39-39 39.05 39.05 0 0 1-39 39"/></svg>`,
};
